
import { ControlLabel } from './MinHoursSelector';

export type ExperienceScope = 'allTime' | 'pastYear' | 'pastMonth';

const SCOPE_OPTIONS: { value: ExperienceScope; label: string }[] = [
  { value: 'pastMonth', label: '3 months' },
  { value: 'pastYear', label: '1 year' },
  { value: 'allTime', label: 'All time' },
];

const ExperienceScopeSelector = ({ value, onChange }: { value: ExperienceScope; onChange: (scope: ExperienceScope) => void }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 4, marginBottom: 8 }}>
    <ControlLabel>Period</ControlLabel>
    {SCOPE_OPTIONS.map(o => (
      <button
        key={o.value}
        onClick={() => onChange(o.value)}
        style={{
          fontSize: 11,
          fontWeight: 500,
          padding: '4px 10px',
          borderRadius: 6,
          cursor: 'pointer',
          border: 'none',
          backgroundColor: value === o.value ? '#38566B' : '#f0f0f0',
          color: value === o.value ? 'white' : '#888',
          transition: 'background-color 0.15s, color 0.15s',
          userSelect: 'none',
        }}
      >
        {o.label}
      </button>
    ))}
  </div>
);

export default ExperienceScopeSelector;
